import type { ReactNode } from 'react';

import { Icon } from '@/components/Icon/Icon';
import { initialsOf } from '@/lib/lenders';

import styles from './RecordList.module.css';

export interface RecordListItem {
  id: string;
  title: string;
  /** One line under the title, e.g. what the record belongs to. */
  meta?: string | null;
}

export interface RecordListProps {
  label: string;
  items: readonly RecordListItem[];
  /** Wraps a row in a link to the record; routing is the caller's. */
  renderLink: (item: RecordListItem, children: ReactNode) => ReactNode;
}

/** A grid of named records, each row opening its own page. */
export function RecordList({ label, items, renderLink }: RecordListProps) {
  return (
    <ul aria-label={label} className={styles.list}>
      {items.map((item) => (
        <li key={item.id}>
          {renderLink(
            item,
            <span className={styles.row}>
              <span aria-hidden="true" className={styles.monogram}>
                {initialsOf(item.title)}
              </span>
              <span className={styles.main}>
                <span className={styles.name}>{item.title}</span>
                {item.meta ? <span className={styles.meta}>{item.meta}</span> : null}
              </span>
              <span className={styles.chevron}>
                <Icon name="caret-right" />
              </span>
            </span>,
          )}
        </li>
      ))}
    </ul>
  );
}
